import React from 'react';
import logo from '../assets/Logo.png';  // Importa el logo

const Footer = () => {
  return (
    <footer>
        <img src={logo} alt="Logo" className="logo-footer" />  {/* Mostrar el logo */}
        <p>
          © {new Date().getFullYear()} Framegonz. Todos los derechos reservados.
        </p>
    </footer>
  );
};

export default Footer;